export const environment = {
  envName: 'Dev',
  production: false,
  configStage: 'dev'
};
